import React from 'react';
import SectionHeader from '../shared/SectionHeader';
import Card from '../shared/Card';

const ServicesSection = () => {
  const services = [
    {
      icon: 'fas fa-warehouse',
      title: 'Real-Time Storage',
      description: 'Immediate assistance for short-term or emergency storage needs with our secure facilities.',
      features: [
        '24/7 access to your belongings',
        'Climate-controlled units available'
      ]
    },
    {
      icon: 'fas fa-truck-moving',
      title: 'Large-Item Delivery',
      description: 'Specialized transportation for bulky items with our professional handling team.',
      features: [
        'Furniture and appliance transport',
        'White-glove delivery service'
      ]
    },
    {
      icon: 'fas fa-shipping-fast',
      title: 'Short-Distance Courier',
      description: 'Fast and reliable local delivery services for all your urgent needs.',
      features: [
        'Same-day delivery options',
        'Real-time tracking available'
      ]
    },
    {
      icon: 'fas fa-people-carry',
      title: 'Moving Support',
      description: 'Comprehensive relocation services for stress-free moving experiences.',
      features: [
        'Packing and unpacking services',
        'Temporary storage solutions'
      ]
    }
    // Add other services similarly
  ];

  return (
    <section id="services" className="py-20 gradient-bg">
      <div className="container mx-auto px-6">
        <SectionHeader
          title="Our"
          highlight="Premium Services"
          subtitle="Tailored solutions designed to meet your storage and delivery needs with excellence."
          className="animate-slide-up"
        />
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <Card
              key={index}
              icon={service.icon}
              title={service.title}
              description={service.description}
              features={service.features}
              className="animate-slide-up"
              style={{ animationDelay: `${0.1 * (index + 1)}s` }}
            />
          ))}
        </div>
        
        {/* Why Choose Us section */}
        <div className="mt-20 bg-white rounded-2xl shadow-xl overflow-hidden animate-slide-up">
          {/* ... rest of the why choose us content ... */}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;